import { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../lib/api";
import PageHeader from "../components/PageHeader";
import { toast } from "sonner";
import { Save } from "lucide-react";

const Field = ({ label, children }) => (
  <div>
    <label className="block text-xs font-semibold uppercase tracking-wider text-gray-500 mb-1.5">{label}</label>
    {children}
  </div>
);

export default function AddPopular() {
  const navigate = useNavigate();
  const [form, setForm] = useState({ title: "", image: "", description: "", order: 0, status: "active" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/popular", { ...form, order: parseInt(form.order) || 0 });
      toast.success("Popular item added");
      navigate("/popular/list");
    } catch {
      toast.error("Failed to add");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="add-popular-page">
      <PageHeader title="Add Popular" subtitle="Feature a promotion on the public homepage" />
      <form onSubmit={submit} className="bg-white border border-gray-200 rounded-sm p-6 max-w-3xl" data-testid="add-popular-form">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Field label="Title">
            <input required value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} className="w-full h-10 px-3 border border-gray-200 rounded-sm text-sm" data-testid="popular-title" />
          </Field>
          <Field label="Image URL">
            <input value={form.image} onChange={(e) => setForm({ ...form, image: e.target.value })} className="w-full h-10 px-3 border border-gray-200 rounded-sm text-sm" data-testid="popular-image" />
          </Field>
          <Field label="Order">
            <input type="number" value={form.order} onChange={(e) => setForm({ ...form, order: e.target.value })} className="w-full h-10 px-3 border border-gray-200 rounded-sm text-sm tabular" data-testid="popular-order" />
          </Field>
          <Field label="Status">
            <select value={form.status} onChange={(e) => setForm({ ...form, status: e.target.value })} className="w-full h-10 px-3 border border-gray-200 rounded-sm text-sm">
              <option value="active">Active</option>
              <option value="inactive">Inactive</option>
            </select>
          </Field>
          <div className="md:col-span-2">
            <Field label="Description">
              <textarea rows={3} value={form.description} onChange={(e) => setForm({ ...form, description: e.target.value })} className="w-full px-3 py-2 border border-gray-200 rounded-sm text-sm" data-testid="popular-description" />
            </Field>
          </div>
        </div>
        <div className="flex justify-end gap-2 mt-6 pt-5 border-t border-gray-100">
          <button type="button" onClick={() => navigate("/popular/list")} className="h-10 px-4 border border-gray-200 rounded-sm text-sm">Cancel</button>
          <button type="submit" disabled={loading} className="h-10 px-5 bg-emerald-500 hover:bg-emerald-600 text-white rounded-sm text-sm font-semibold inline-flex items-center gap-2 disabled:opacity-50" data-testid="popular-submit">
            <Save size={14} /> {loading ? "Saving..." : "Save"}
          </button>
        </div>
      </form>
    </div>
  );
}
